// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BackgroundImage-module-wrapper","image":"BackgroundImage-module-image"};